module.exports = __webpack_public_path__ + "img/financial-welfare.23ca5301.webp";